export const formatDatetimeToDate = (datetime: string) =>
  new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'numeric',
    year: '2-digit',
  }).format(new Date(datetime));
